import React from 'react';
import { Link } from 'react-router-dom';
import { FaTiktok } from 'react-icons/fa';
import footerLogo from '../assets/Footerimg.png';
import {
  Linkedin,
  Twitter,
  Facebook,
  Instagram,
  Youtube,
  Mail,
  Phone,
  MapPin,
  Cloud
} from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/tool">Job Center</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">Legal</h3>
          <ul className="footer-links">
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/settings">Terms & Conditions</Link></li>
          </ul>
        </div>

        <div className="footer-column footer-center">
          <div className="footer-branding">
          <img src={footerLogo} alt="JobQue Logo" className="footer-logo" />
  <h2 className="footer-brand-name">JobQue</h2>
</div>
          <p className="footer-description">
          Jobque.ai is an AI-powered job search assistant. It monitors company
        career pages based on your search preferences and alerts you the moment a 
        relevant job is posted — helping you apply early and beat the competition.
          </p>
        </div>

        <div className="footer-column connect-column">
  <h3 className="footer-title">Connect With Us</h3>
  <div className="footer-social-links grid-layout">
    <a href="https://www.linkedin.com/company/jobqueai/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
      <Linkedin className="footer-social-icon" />
    </a>
    <a href="https://x.com/jobqueai" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
      <Twitter className="footer-social-icon" />
    </a>
    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
      <Facebook className="footer-social-icon" />
    </a>
    <a href="https://www.instagram.com/jobqueai/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
      <Instagram className="footer-social-icon" />
    </a>
    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
      <Youtube className="footer-social-icon" />
    </a>
    <a href="https://www.tiktok.com/@jobqueai" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="footer-social-icon">
    <path fill="currentColor" d="M448 209.9v-58.6c-22.1.1-43.5-6.7-61.4-19.5-17.8-12.7-31.6-30.1-39.7-50-5.6-13.6-8.5-28.2-8.5-43.5h-66.7v297.1c0 10.7-2.5 20.7-6.9 29.7-6.4 13.5-16.4 25-29 33.2-13.2 8.7-28.7 13.6-45.4 13.6-19.6 0-37.8-6.9-52-18.4-14.5-11.8-25-28.4-29.2-47.4-1.5-7.2-2.3-14.8-2.3-22.6 0-43.1 29.1-79.4 68.7-91.1 9.5-2.8 19.5-4.2 29.9-4.2 5.2 0 10.4.3 15.4.9V156.3c-5.1-.7-10.3-1.1-15.4-1.1-14.7 0-29 2.2-42.5 6.3-49.1 15.2-86.5 58.6-92.2 111.9-.4 4.1-.6 8.3-.6 12.5 0 81.7 66.2 148 148 148 37.3 0 71.5-13.7 97.7-36.3 33-28.6 54.3-70.7 54.3-118.7z"/>
  </svg>
</a>

  </div>
</div>

      </div>

      <div className="footer-bottom">
        <p>© 2021–2025 Jobque.ai. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="footer-divider">|</span>
          <Link to="/settings">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;